var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{on:{"submit":function($event){$event.preventDefault();},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;$event.preventDefault();}}},[_c('p',[_vm._v(_vm._s(_vm.$t('simpleContainerElementForm.noConfigurationOptions')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }